import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from "@angular/flex-layout";
import { Ng2DragDropModule } from 'ng2-drag-drop';
import { MaterialModule } from './material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SortablejsModule } from 'angular-sortablejs';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { GlobalpopupModule } from './globalpopup/globalpopup.module'
import { ColorHueModule } from 'ngx-color/hue';
import { HttpModule } from '@angular/http';

import { GoogleSignInComponent } from 'angular-google-signin';
import { GoogleService } from './Google.service';
import { NgxElectronModule } from 'ngx-electron';
import {IS_ElectronService} from './IS_Electron.service';
import { AuthService } from '../../assets/angular5-social-login';
import { SocialUser } from '../../assets/angular5-social-login';
import { LoginObservableService,subscribenowPopup } from './loginObservable.service'
import { TemplateAsEnrichmentComponent } from '../bookShared/enrichmentTabs/template-as-enrichment/template-as-enrichment.component';
import { MatFormFieldModule } from '@angular/material';
import { MatInputModule } from '@angular/material';
import { MatCardModule } from '@angular/material/card';
import { SlideshowModule } from 'ng-simple-slideshow';
import { MouseactionsDirective } from './mouseactions.directive'
import { LanguageTranslateObservableService } from './languageTranslateObservable.service';
// angular translate
import { HttpClient,HttpClientModule } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

import {
  SocialLoginModule,
  AuthServiceConfig,
  GoogleLoginProvider,
  FacebookLoginProvider,
} from "../../assets/angular5-social-login"; 
import { ImageCropperModule } from 'ngx-image-cropper';

export function getAuthServiceConfigs() {
  let config = new AuthServiceConfig(
      [
        {
          id: FacebookLoginProvider.PROVIDER_ID,
          provider: new FacebookLoginProvider("561602290896109")
        },
        {
          id: GoogleLoginProvider.PROVIDER_ID,
         
          provider: new GoogleLoginProvider("258982534697-unv38a7b7hkrkhiac2kj76phr5b9d6d5.apps.googleusercontent.com")
        },
      ]
  );
  return config;
}
// 1058901312314-blli9v7q4a2bthrvrvnvrrqn1dtt4ceu.apps.googleusercontent.com

@NgModule({
  imports: [
    CommonModule,
    FlexLayoutModule,
    Ng2DragDropModule.forRoot(),
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    SortablejsModule.forRoot({ animation: 150 }),
    PdfViewerModule,
    GlobalpopupModule,
    ColorHueModule,
    HttpModule,
    // HttpClientModule,
    SocialLoginModule,
    ImageCropperModule,
    NgxElectronModule, HttpClientModule,
    MatFormFieldModule,
    MatInputModule,
    MatCardModule,
    SlideshowModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  entryComponents: [TemplateAsEnrichmentComponent, subscribenowPopup],
  exports: [FlexLayoutModule, Ng2DragDropModule, MaterialModule, FormsModule, ReactiveFormsModule, SortablejsModule, PdfViewerModule, GlobalpopupModule, ColorHueModule, HttpModule, HttpClientModule, ImageCropperModule, NgxElectronModule, TranslateModule, TemplateAsEnrichmentComponent, MatFormFieldModule,
    MatInputModule, MatCardModule, SlideshowModule, MouseactionsDirective],
  declarations: [TemplateAsEnrichmentComponent, subscribenowPopup, MouseactionsDirective],
  providers: [IS_ElectronService, GoogleService, {
    provide: AuthServiceConfig,
    useFactory: getAuthServiceConfigs
  },LoginObservableService,LanguageTranslateObservableService]
})
export class DependentModule { }


// WEBPACK FOOTER //
// ./src/app/shared/dependent.module.ts